const webservice = process.env.REACT_APP_WEBSERVICE;

export default webservice;
